
var Button = require('../button');

module.exports = new Class({
	Extends: Button
	,Tag: 'htk-bar-button'
	
	,_showText: true
});
